import React from 'react'
import { DemoRegistrationForm } from './DemoRegistrationForm'
import { DemoSession } from '../types'

export const DemoEntryPanel: React.FC = () => {
  const handleRegistrationComplete = (_session: DemoSession) => {
    // 試験画面へ遷移
    window.location.href = '/exams/demo/exam'
  }

  return (
    <div className="demo-entry">
      <div className="demo-entry__card">
        <h1 className="demo-entry__heading">試験監視機能デモ</h1>
        <div className="demo-entry__body">
          <DemoRegistrationForm
            onRegistrationComplete={handleRegistrationComplete}
          />
        </div>
      </div>
    </div>
  )
}
